<template>
<div class="mt-4">
    <v-card class="mx-auto" max-width="600">
        <v-toolbar color="white" elevation="0" class="text-center">

            <v-row>

                <v-col class="d-flex justify-space-around">
                    <v-toolbar-title>สมัครสมาชิก</v-toolbar-title>
                </v-col>

            </v-row>

        </v-toolbar>
        <v-divider></v-divider>

         <div class="pa-5 pb-0 html" v-if="page">
            <div v-html="page.html"  v-if="page.html" />
         </div>

        <v-card-text class="pa-5" v-if="!complete">
            <div class="text-center" v-if="!group_id">
                <div class="big">โปรดเลือกประเภทของสมาชิกที่ต้องการสมัครค่ะ</div>

                <div class="ma-3 pt-1 pb-1">

                    <v-btn class="ma-2 " large color="light-blue darken-4" dark  rounded block @click="group_id=1"  >
                        Sub Dlrs.
                    </v-btn>

                </div>

                <div class="ma-3 pt-1 pb-1">

                    <v-btn class="ma-2 " large color="teal darken-3"  dark rounded block @click="group_id=2"  >
                        นักเรียน /
                        นักศึกษา
                    </v-btn>

                </div>

                <div class="ma-3 pt-1 pb-1">

                    <v-btn class="ma-2 " large color="cyan darken-3" dark rounded block @click="group_id=3">
                        บุคคลทั่วไป
                    </v-btn>

                </div>

            </div>
            <div v-if="group_id">
                <FormAll :group_id="group_id" @complete="setData" v-if="!otp" />
                <div>

                    <Otp title="ยืนยันการสมัคร" :item="data" :sms="sms" :otp="otp" v-if="otp" class="animate__animated animate__zoomIn" @reSend="reSend" @confirm="setRegister" />
                </div>

            </div>

        </v-card-text>
        <v-card-text v-if="complete">

            <div v-html="msg" class="animate__animated animate__zoomIn"></div>

        </v-card-text>
    </v-card>
</div>
</template>

<script>
import FormAll from '@/views/Member/FormAll'
import Otp from '@/views/Member/Otp'
export default {

    components: {
        FormAll,
        Otp
    },

    props: {

        page: null

    },

    data: () => ({
        group_id: null,
        otp: null, 
        complete: null,

        msg: null,

        sms: null,
        data: null

    }),

    computed: {

    },

    watch: {

    },
    methods: {

        setData(val) {
            this.data = val

            this.setMemberTmp()
        },
        setMemberTmp() {

            this.$FULL_LOADING = true

            const formData = this.$formData(
                this.data
            );

            let url = "member/setTmp";
            let $vm = this;
            this.$API
                .post(url, this.formData(formData))
                .then(function (res) {
                    $vm.checkApi(res);
                    $vm.getOtp();

                    $vm.$FULL_LOADING = null

                })
                .catch(function (error) {
                    console.log(error);
                });

        },

        setRegister() {

            this.data.sms_id = this.sms.sms_id
            this.$FULL_LOADING = true

            const formData = this.$formData(
                this.data
            );

            let url = "member/setRegister";
            let $vm = this;
            this.$API
                .post(url, this.formData(formData))
                .then(function (res) {
                    $vm.checkApi(res);
                    if (res.data.re = 'success') {
                        $vm.complete = true
                        $vm.msg = res.data.msg
                    }
                    $vm.$FULL_LOADING = null

                })
                .catch(function (error) {
                    console.log(error);
                });

        },

        reSend() {
            this.getOtp(true)

        },

        getOtp(resend) {

            this.$FULL_LOADING = true

            if (resend) { //ส่งอีกครั้ง ใช้เลข Otp อันเดิม
                this.data.otp = this.otp
            }

            const formData = this.$formData(
                this.data
            );

            let url = "member/getOtp?type=register";
            let $vm = this;
            this.$API
                .post(url, this.formData(formData))
                .then(function (res) {
                    $vm.checkApi(res);
                    if (res.data.re == 'success') {
                        $vm.sendOtp(res.data.sms)
                        $vm.otp = res.data.otp
                        $vm.sms = res.data.sms
                        $vm.$FULL_LOADING = null

                    }

                })
                .catch(function (error) {
                    console.log(error);
                });

        },

    },
    created() {

    },
};
</script>
